/* eslint-disable import/prefer-default-export */
import { ApiBase } from '@/api/api'
import { makeGetRequest } from '@/api/fetchCalls'
import type {
  UserDetail,
  UserLabel,
  UserListResponse,
  UserParams,
} from '@/types/user'

export async function getUsers(
  { page = 1, pageSize = 20, search, ordering }: UserParams = {},
  requestParams: { signal?: AbortSignal } = {}
): Promise<UserListResponse> {
  return (await makeGetRequest(
    ApiBase +
      `/users?page=${page}&page_size=${pageSize}` +
      (search ? `&search=${search}` : '') +
      (ordering ? `&ordering=${ordering}` : ''),
    requestParams
  )) as Promise<UserListResponse>
}

export async function getUsersLabels(): Promise<Array<UserLabel>> {
  return (await makeGetRequest(ApiBase + '/users/labels')) as Promise<
    Array<UserLabel>
  >
}

export async function getUserDetails(): Promise<UserDetail> {
  return (await makeGetRequest(ApiBase + '/users/me')) as Promise<UserDetail>
}
